exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".help-wrapper{padding:20pt;background:#fff}.help-wrapper ul{list-style:none;font-size:150%}.help-wrapper li{padding:16px}.help-wrapper .h{margin-bottom:8px;font-size:105%}.help-wrapper a{color:#3da8b9}", "", {"version":3,"sources":["/home/steven/dev/Sporte/sporte2/src/components/Help.vue"],"names":[],"mappings":"AACA,cACE,aAAc,AACd,eAAkB,CACnB,AACD,iBACE,gBAAiB,AACjB,cAAgB,CACjB,AACD,iBACE,YAAc,CACf,AACD,iBACE,kBAAmB,AACnB,cAAgB,CACjB,AACD,gBACE,aAAe,CAChB","file":"Help.vue","sourcesContent":["\n.help-wrapper {\n  padding: 20pt;\n  background: white;\n}\n.help-wrapper ul {\n  list-style: none;\n  font-size: 150%;\n}\n.help-wrapper li {\n  padding: 16px;\n}\n.help-wrapper .h {\n  margin-bottom: 8px;\n  font-size: 105%;\n}\n.help-wrapper a {\n  color: #3DA8B9;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1c0517c3","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Help.vue
// module id = 966
// module chunks = 20